import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import editColor from "../../../../assets/images/icons/edit-color.svg";
import edit from "../../../../assets/images/icons/edit.svg";
import { updateFaqCMSData } from "./actions";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import DeleteModel from "../membership/deleteModel";
import { getFaqDetailsAction } from "../../../App/actions";

const validationSchema = Yup.object({
  faqs: Yup.array()
    .of(
      Yup.object().shape({
        title: Yup.string().required("title can not be empty"),
        paragraph: Yup.string().required("paragraph can not be empty"),
      }),
    )
    .required("FAQ can not be empty")
    .min(1, "please add minimum 1 FAQ"),
});

const EditFaqCMS = () => {
  const [faqEdit, setFaqEdit] = useState(false);
  const faq = useSelector((state) => state?.cms?.faq);
  const dispatch = useDispatch();
  const initialState = {
    faqs: faq?.faqs
      ? faq?.faqs
      : [
          {
            title: "",
            paragraph: "",
          },
        ],
  };
  useEffect(() => {
    dispatch(getFaqDetailsAction());
  }, []);
  const handleSubmit = async (values) => {
    const form_data = new FormData();
    form_data.append("faqs", JSON.stringify(values.faqs));
    dispatch(updateFaqCMSData(form_data, setFaqEdit));
  };

  return (
    <>
      <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
        {({ values, errors }) => {
          return (
            <Form className="usefulFeatureForm">
              <h3 className={`resourceAddTitle ${faqEdit ? "editTitle" : ""}`}>
                FAQ
                {faqEdit ? (
                  <button
                    className="savebtn"
                    type="submit"
                    onClick={() => {
                      setFaqEdit(false);
                      handleSubmit(values);
                    }}
                  >
                    Save <img src={editColor} alt="" />
                  </button>
                ) : (
                  <span onClick={() => setFaqEdit(true)} className="edit">
                    <span>Edit</span> <img src={edit} alt="edit" />
                  </span>
                )}
              </h3>
              <div className="usefulFeatureFormBG">
                <FieldArray
                  name="faqs"
                  render={(arrayHelpers) => (
                    <>
                      {faqEdit ? (
                        <button
                          type="button"
                          className="addNewItem mb-3"
                          onClick={() =>
                            arrayHelpers.push({
                              // id:Date.now(),
                              title: "",
                              paragraph: "",
                            })
                          }
                        >
                          Add Item
                        </button>
                      ) : null}
                      {values.faqs.map((_value, index) => (
                        <div className="faqQuestionsWrap position-relative" key={index}>
                          <div className="d-flex justify-content-between align-items-center mb-20">
                            <span className="labelCount">0{index + 1}</span>
                            {faqEdit ? (
                              <>
                                {" "}
                                {values.faqs.length > 0 && (
                                  <DeleteModel
                                    onClick={() => {
                                      arrayHelpers.remove(index);
                                    }}
                                  />
                                )}
                              </>
                            ) : null}
                          </div>
                          <div className={faqEdit ? "editField inputStyle" : "inputStyle"}>
                            <label htmlFor={`faqs${index + 1}`}>Title</label>
                            <Field name={`faqs[${index}].title`} placeholder="question" id={`faqs${index + 1}`} readOnly={!faqEdit} disabled={!faqEdit} />
                            <ErrorMessage name={`faqs[${index}].title`} className="errorMessage" component="div" />
                          </div>
                          <div className="multilineForm">
                            <label className={!faqEdit ? " editLabel" : ""}>Paragraph</label>
                            <div className="editField inputStyle mb-0">
                              <Field name={`faqs[${index}].paragraph`} component="textarea" readOnly={!faqEdit} disabled={!faqEdit} />
                              <ErrorMessage name={`faqs[${index}].paragraph`} className="errorMessage" component="div" />
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                />
                {typeof errors.faqs === "string" ? <p className="errorMsg">{errors.faqs}</p> : null}
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default withRouter(EditFaqCMS);
